import { AnalyticsField } from '@/store/analytics/utils/enums'

export const ANALYTICS_DELAY_TO_NOTIFICATE = 5

export const ANALYTICS_DATE_STORAGE_KEY = 'ANALYTICS_DATE'

export const ANALYTICS_PERIOD_NAMING = {
  day: 'Daily',
  week: 'Weekly',
  month: 'Monthly',
  quarter: 'Quarterly',
  year: 'Yearly',
}

export const ANALYTICS_CAPTIONS = {
  [AnalyticsField.DATE]: 'Date',

  [AnalyticsField.ROOT_ID]: 'Root',

  [AnalyticsField.ASSET]: 'Asset',
  [AnalyticsField.ASSET_TICKER]: 'Asset Ticker',
  [AnalyticsField.ASSET_TYPE]: 'Asset Type',

  [AnalyticsField.ACCOUNT]: 'Account',
  [AnalyticsField.ACCOUNT_TYPE]: 'Account Type',

  [AnalyticsField.CATEGORY_ACCOUNT]: 'Category Account',
  [AnalyticsField.CATEGORY_ACCOUNT_TYPE]: 'Category Account Type',

  [AnalyticsField.CATEGORY]: 'Category',
  [AnalyticsField.SUBCATEGORY]: 'Subcategory',

  [AnalyticsField.TAGS]: 'Tags',

  [AnalyticsField.POSITION_CLOSE]: 'Value',
  [AnalyticsField.POSITION_COST]: 'Cost',
  [AnalyticsField.POSITION_GAIN]: 'Gain',

  [AnalyticsField.D_POSITION_CLOSE]: 'Value Change',
  [AnalyticsField.D_POSITION_COST]: 'Cost Change',
  [AnalyticsField.D_POSITION_GAIN]: 'Gain Change',

  [AnalyticsField.AMOUNT]: 'Amount',
  [AnalyticsField.D_AMOUNT]: 'Amount Change',

  [AnalyticsField.ASSET_CLOSE]: 'Price',

  [AnalyticsField.VALUE_START]: 'Value Start',
  [AnalyticsField.CHANGE]: 'Change',
  [AnalyticsField.PERCENT_CHANGE]: '% Change',
  [AnalyticsField.CAPITAL_FLOW]: 'Capital Flow',
  [AnalyticsField.VALUE_END]: 'Value End',
  [AnalyticsField.IRR]: 'IRR',
  [AnalyticsField.MOIC]: 'Multiple (MOIC)',

  [AnalyticsField.REALIZED_GAIN]: 'Realized',
  [AnalyticsField.UNREALIZED_GAIN]: 'Unrealized',

  // Commitments
  [AnalyticsField.INCEPTION_DATE]: 'Inception Date',
  [AnalyticsField.ORIGINAL_COMMITMENT]: 'Original Commitment',
  [AnalyticsField.REMAINING_COMMITMENT]: 'Remaining Commitment',
  [AnalyticsField.INVESTED_CAPITAL]: 'Total Contributions',
  [AnalyticsField.RECALLABLE_CAPITAL]: 'Recallable Returned Capital',
  [AnalyticsField.RETURNED_CAPITAL]: 'Total Returned Capital',
  [AnalyticsField.INCOME]: 'Income',
  [AnalyticsField.TOTAL_DISTRIBUTION]: 'Total Distribution',
  [AnalyticsField.GAIN_LOSS]: 'Gain / (Loss)',
  [AnalyticsField.CURRENT_BALANCE]: 'Current Balance',
}
